// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1yYSt","label":"CategoryService_label__omXD3","location":"CategoryService_location__1kHgH"};